import type { IsoDate } from '../utils/age';

export interface TeamMember {
  name: string;
  role: string;
  /** `YYYY-MM-DD`; the age in the description is derived from it. */
  birthDate: IsoDate;
  img: string;
  /** `{age}` is replaced with the current age, so the text never goes stale. */
  description: string;
}

export const teamMembers: TeamMember[] = [
  {
    name: "Nicolas Bühler",
    role: "Forstwart EFZ in Ausbildung",
    birthDate: "2006-06-07",
    img: "/img/nicolas.jpg",
    description:
      "Mein Name ist Nicolas Bühler, ich bin {age} Jahre alt und mache gerade eine Ausbildung zum Forstwart EFZ. Mit Herz und Seele verbringe ich sehr viel Freizeit in unserer Werkstatt. Zu meinen Aufgaben in unserem Team gehört, den Rundholzeinkauf, den Transport und das Aufsägen des gekauften Holzes zu organisieren. Aber auch die Arbeit in der Werkstatt und im Büro, um für Ordnung zu sorgen, gehören dazu. Es bereitet mir eine riesige Freude zu sehen, wie sich unsere Werkstatt in den letzten zwei Jahren verändert hat.",
  },
  {
    name: "Severin Grossert",
    role: "Zimmermann EFZ in Ausbildung",
    birthDate: "2006-07-10",
    img: "/img/sevi.jpg",
    description:
      "Hallo, ich bin Severin Grossert, {age} Jahre alt, und mache eine Lehre als Zimmermann EFZ. 2020 habe ich in meiner Garage eine Werkstatt eingerichtet und zusammen mit meinem besten Kollegen Nicolas die ersten Produkte hergestellt. Jetzt haben wir eine 65 m² grosse Werkstatt und realisieren grosse Projekte wie Betten, Garderoben und Tische. Mit viel Leidenschaft verbringe ich meinen Feierabend und mein Wochenende in der Werkstatt.",
  },
  {
    name: "Moritz Wiesmann",
    role: "Zimmermann EFZ in Ausbildung",
    birthDate: "2009-02-18",
    img: "/img/moritz.jpg",
    description:
      "Mein Name ist Moritz Wiesmann, ich bin {age} Jahre alt und mache eine Ausbildung als Zimmermann EFZ. Meine Freizeit verbringe ich gerne in der Werkstatt mit meinen Kollegen. Dort erledigen wir mit viel Freude diverse Arbeiten aus Holz, die wir danach verkaufen. Zu meinen Aufgaben gehören das Fertigen und Richten von Schneidebrettern sowie anderen Aufträgen. Besonders Spass macht es mir zu sehen, wie unsere Produkte beim Arbeiten Form annehmen und die Entwicklung unseres Teams zu verfolgen.",
  },
  {
    name: "Silvan Jegher",
    role: "Landwirt EFZ in Ausbildung",
    birthDate: "2008-09-26",
    img: "/img/silvan.jpg",
    description:
      "Ich heisse Silvan Jegher, ich bin {age} Jahre alt und mache gerade eine Ausbildung als Landwirt EFZ. Neben der Ausbildung verbringe ich meine restliche Zeit in der Werkstatt. Mein Beitrag zum Team sind Schleifarbeiten sowie das Wachsen von Produkten, aber meistens helfe ich einfach dort aus, wo es mich braucht. Es macht mir viel Spass zu sehen, wie immer mehr Leute anpacken, mithelfen und unser Team wächst.",
  },
];
